import { __awaiter, __generator } from "tslib";
import { IconError, IconGreenCheck, IconTooltip } from '@anex/common';
import axios from 'axios';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { Alert } from '../../../../../components';
export var PromotionCode = inject('config', 'summaryStore', 'saleStore')(observer(function (props) {
    var _a = useState(false), statusMessage = _a[0], setStatusMessage = _a[1];
    useEffect(function () {
        if (props.saleStore.promo && props.saleStore.promo.success) {
            props.summaryStore.getSummary(props.summaryStore.contractCode, props.summaryStore.hardwareCode, props.summaryStore.nbnLocId, props.summaryStore.voipCode, props.saleStore.promo.amount);
        }
    }, [props.saleStore.promo]);
    var promo = props.saleStore.promo;
    function onApplyClick() {
        setStatusMessage(false);
        props.saleStore.isLoading(true);
        applyPromo();
    }
    function applyPromo() {
        return __awaiter(this, void 0, void 0, function () {
            var trimValue, apitoken, r, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        trimValue = props.saleStore.promoCode.trim();
                        props.saleStore.setPromoCode(trimValue);
                        apitoken = "" + props.config.anexApiToken;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, axios({
                                headers: {
                                    Authorization: 'Bearer ' + apitoken,
                                },
                                method: 'get',
                                params: {
                                    wholesaleCustomerCode: "" + props.config.wholesaleCustomerCode,
                                    contractCode: "" + props.summaryStore.contractCode,
                                    promoCode: trimValue,
                                },
                                url: props.config.anexApiBaseUrl + "/api/v1/sale/promo",
                            })];
                    case 2:
                        r = _a.sent();
                        props.saleStore.setPromo(r.data);
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        props.saleStore.setPromo(null);
                        return [3, 4];
                    case 4:
                        props.saleStore.isLoading(false);
                        setStatusMessage(true);
                        return [2];
                }
            });
        });
    }
    return (React.createElement("div", { className: "form-group" },
        React.createElement("label", null, "Have a promotion code? Enter it below"),
        React.createElement("div", { className: "input-group" },
            React.createElement(InputMask, { placeholder: "Promotion code", className: "form-control", mask: "", value: props.saleStore.promoCode, disabled: promo && promo.success, onChange: function (e) {
                    props.saleStore.setPromoCode(e.currentTarget.value);
                } }),
            React.createElement("button", { type: "button", className: "btn btn-next btn-navy", disabled: props.saleStore.promoCode.length < 1 || (promo && promo.success), onClick: onApplyClick }, "Apply")),
        statusMessage &&
            (promo ? (promo.success ? (React.createElement(Alert, { dismissible: false, message: "Your promo code of $" + (promo.amount / 100).toFixed(2) + " was applied.", type: "success", title: React.createElement(IconGreenCheck, null) })) : (React.createElement(Alert, { dismissible: false, message: promo.message, type: "warning", title: React.createElement(IconTooltip, { fill: "#856404" }) }))) : (React.createElement(Alert, { dismissible: false, message: "Unable to apply code. Server error has occured.", type: "danger", title: React.createElement(IconError, null) })))));
}));
//# sourceMappingURL=PromotionCode.js.map